import * as tslib_1 from "tslib";
import api from '../api';
import { defaultDocumentation, Documentation } from 'src/models/Documentation';
var DocumentationApi = /** @class */ (function () {
    function DocumentationApi() {
    }
    DocumentationApi.get = function (headId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var endpoint, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = DocumentationApi.resource(headId);
                        return [4 /*yield*/, api.get(endpoint)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, !!data ? new Documentation(data) : null];
                }
            });
        });
    };
    DocumentationApi.create = function (userId, headId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var endpoint, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = DocumentationApi.resource(headId);
                        return [4 /*yield*/, api.put(endpoint, tslib_1.__assign({}, defaultDocumentation, { userId: userId }))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Documentation(data)];
                }
            });
        });
    };
    DocumentationApi.update = function (documentation) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var endpoint;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = DocumentationApi.resource(documentation.id);
                        return [4 /*yield*/, api.post(endpoint, documentation)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DocumentationApi.resource = function (id) { return "api/tasks/documentation/" + id; };
    return DocumentationApi;
}());
export default DocumentationApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/DocumentationApi.ts
// module id = 742
// module chunks = 0